/* Copyright (c) 2018 Verge Technologies
 * @file breadCrumb.js
 * @author Brenton Watt
 * @description Component for bread crumbs in Seperations
 */

import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';

const BreadCrumb = (props) => {
  return (
    <div>
      <div className="breadcrumb">
        <ul className={props.products ? 'left' : ''}>
          {props.crumbs.map((crumb, index) => {
            if (crumb.title === 'Products') {
              return (<li key={crumb.link}>
                <a onClick={() => props.history.push('/products')}>
                  <span>{crumb.title.replace(/\w+/g, _.capitalize)}&nbsp;{index + 1 === props.crumbs.length ? '' : '/'}&nbsp;</span>
                </a>
              </li>)
            }
            return (
              <li key={crumb.link}>
                <Link to={crumb.link}>
                  <span>{crumb.title.replace(/\w+/g, _.capitalize)}&nbsp;{index + 1 === props.crumbs.length ? '' : '/'}&nbsp;</span>
                </Link>
              </li>
            );
          })}
        </ul>
        <div className="right" style={{ display: props.products ? 'block' : 'none' }}>
          <label>Sort by</label>
          <select name="sort" value={props.sortBy} onChange={props.products ? props.sortChange() : null}>
            <option value="sugg" defaultValue>
              Suggested
            </option>
            <option value="nameAsc">Name (Ascending)</option>
            <option value="nameDsc">Name (Descending) </option>
            <option value="suppliersAsc">Suppliers (Ascending)</option>
            <option value="suppliersDsc">Suppliers (Descending)</option>
          </select>
        </div>
      </div>
    </div>
  );
};

BreadCrumb.propTypes = {
  crumbs: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  })).isRequired,
  products: PropTypes.bool.isRequired,
  sortBy: PropTypes.string,
};

BreadCrumb.defaultProps = {
  sortBy: 'sugg',
};

export default withRouter(BreadCrumb);



// WEBPACK FOOTER //
// ./src/components/BreadCrumb/breadCrumb.js